import { BaseHttpService } from './base-http.service'

export default new (class AuthService extends BaseHttpService {
    getListCompanies(path: string, params: any): Promise<any> {
        return super.getPromise(path, params)
    }
})()